import { useMutation } from '@tanstack/react-query';

import { GET_APP_TOKENS_QUERY_KEY } from './useGetAppTokens';

import { queryClient } from '@/lib/queryClient';
import AppTokensService, {
  CreateAppTokenDto,
} from '@/services/AppTokensService';

export function useCreateAppToken() {
  const { mutateAsync, isPending } = useMutation({
    mutationFn: (createAppTokenDto: CreateAppTokenDto) =>
      AppTokensService.createAppToken(createAppTokenDto),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: GET_APP_TOKENS_QUERY_KEY,
      });
    },
  });

  return {
    createAppToken: mutateAsync,
    isLoading: isPending,
  };
}
